import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { getBlogs, resolveImg } from "@/lib/api";

const Blog = () => {
  const { data: blogs = [] } = useQuery({ queryKey: ["blogs"], queryFn: getBlogs });
  return (
    <Layout>
      <Seo
        title="Gokarna Pooja & Temple Blog | Guides for Devotees"
        description="Helpful guides for devotees — best pooja for marriage problems, temple pooja booking process, Gokarna temple significance, and visit guides."
      />
      <section className="bg-secondary text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-16">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-gold">Blog</span>
          <h1 className="mt-2 font-heading text-4xl sm:text-5xl text-white tracking-tight">Guidance for Devotees</h1>
          <p className="mt-4 max-w-2xl text-white/80">Honest answers to what devotees search for — poojas, booking, temple significance, and travel tips.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((b, i) => (
            <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="reveal group flex flex-col bg-white border border-border rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all" style={{ animationDelay: `${i * 0.07}s` }}>
              <div className="h-44 overflow-hidden">
                <img src={resolveImg(b.cover_image)} alt={b.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <span className="text-xs tracking-[0.15em] uppercase font-semibold text-primary">{b.category}</span>
                <h2 className="mt-2 font-heading text-2xl text-secondary leading-tight group-hover:text-primary transition-colors">{b.title}</h2>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-3 flex-1">{b.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary">Read article <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Blog;
